module.exports = __webpack_public_path__ + "static/reveal_password.svg";